import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import type {CustomGapSizeOptionProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-dash-option/components/custom-gap-size-option/custom-gap-size-option.types';
import {
  CUSTOM_GAP_MAX_SIZE,
  CUSTOM_GAP_MIN_SIZE,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-dash-option/components/custom-gap-size-option/custom-gap-size-option.types';

export function CustomGapSizeOption({...props}: CustomGapSizeOptionProps): ReactElement {
  const onChangeGapSize = (gapSize: number): void => {
    props.onUpdateGapSize(gapSize, false);
  };

  const onChangeGapSizeEnded = (gapSize: number): void => {
    props.onUpdateGapSize(gapSize);
  };

  return (
    <ContextualMenuSliderOptions
      id="custom-line-gap-size"
      className={props.className}
      value={props.gapSize}
      label={window.i18next.t('pmwjs_gap_size')}
      range={{
        min: CUSTOM_GAP_MIN_SIZE,
        max: CUSTOM_GAP_MAX_SIZE,
      }}
      transformDisplay={{
        min: CUSTOM_GAP_MIN_SIZE,
        max: CUSTOM_GAP_MAX_SIZE,
      }}
      onChange={onChangeGapSize}
      onChangeEnded={onChangeGapSizeEnded}
    />
  );
}
